export const YoutubeIconSmall = () => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 21.5C16.799 21.5 21.5 16.799 21.5 11C21.5 5.20101 16.799 0.5 11 0.5C5.20101 0.5 0.5 5.20101 0.5 11C0.5 16.799 5.20101 21.5 11 21.5Z"
                fill="#2E2E2E"
                stroke="white"
            />
            <path
                d="M16.5999 13.2351C16.5987 13.6591 16.4297 14.0653 16.1299 14.3651C15.8301 14.6649 15.4239 14.8339 14.9999 14.8351H6.9999C6.57594 14.8339 6.16969 14.6649 5.8699 14.3651C5.57011 14.0653 5.40114 13.6591 5.3999 13.2351V8.76455C5.40114 8.34058 5.57011 7.93434 5.8699 7.63455C6.16969 7.33476 6.57594 7.16579 6.9999 7.16455H14.9999C15.4239 7.16579 15.8301 7.33476 16.1299 7.63455C16.4297 7.93434 16.5987 8.34058 16.5999 8.76455V13.2351ZM9.84225 12.3693L12.8705 10.8022L9.84225 9.23514V12.3693Z"
                fill="white"
            />
        </svg>
    );
};
